/**
 * MODAL: CHANGE PASSWORD
 * Modal pour changer le mot de passe d'un utilisateur (superadmin uniquement)
 */

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import type { ChangePasswordInput } from '../../schemas/user';
import { changePasswordSchema } from '../../schemas/user';
import { Form, FormInput } from '../ui';
import { Modal, ModalFooter } from '../ui/modal';

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  userEmail: string;
  onSubmit: (data: ChangePasswordInput) => Promise<void>;
}

export function ChangePasswordModal({
  isOpen,
  onClose,
  userEmail,
  onSubmit,
}: ChangePasswordModalProps) {
  const form = useForm<ChangePasswordInput>({
    resolver: zodResolver(changePasswordSchema),
  });

  const handleClose = () => {
    form.reset();
    onClose();
  };

  const handleFormSubmit = async (data: ChangePasswordInput) => {
    await onSubmit(data);
    handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Changer le mot de passe"
      size="md"
      footer={
        <ModalFooter
          onCancel={handleClose}
          submitLabel="Modifier"
          isSubmitting={form.formState.isSubmitting}
          formId="change-password-form"
        />
      }
    >
      <Form {...form}>
        <form id="change-password-form" onSubmit={form.handleSubmit(handleFormSubmit)}>
          <div className="flex flex-col gap-4">
            <div className="text-sm text-zinc-600">
              Utilisateur : <span className="font-semibold text-zinc-900">{userEmail}</span>
            </div>

            <FormInput
              control={form.control}
              name="newPassword"
              label="Nouveau mot de passe"
              type="password"
              required
              placeholder="Minimum 8 caractères"
            />
          </div>
        </form>
      </Form>
    </Modal>
  );
}
